module.exports = __webpack_public_path__ + "i18n/ru.c1d92c2191cb2df0b040bcfdeebf9880.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/ru.json
// module id = 1066
// module chunks = 60